"use strict";

exports.__esModule = true;
exports.getLabel = getLabel;
var _Utils = require("../../../Utils");
var path = require("ramda").path;
var unFormattedValueTimeline = ["time-series-kind", "time-series-process", "time-series-part-instance", "time-series-operator"];
function getLabel(labels, document) {
  return labels.map(function (label) {
    var value = path(label.split("."), document) || "";
    return unFormattedValueTimeline.includes(document.type) ? value : Array.isArray(value) ? value : (0, _Utils.capitalizeWords)(value.toString().split(/[,_.-]/));
  }).filter(function (val) {
    return !!val;
  });
}